import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoTranslatorConfig } from '@/data/landingConfig/landingPhotoTranslatorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoTranslator } from './schemaObject';

interface Props {}
const PhotoTranslator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoTranslator} />
			<LandingTemplate
				data={landingPhotoTranslatorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiImageTranslator()}
			/>
		</>
	);
};

export default PhotoTranslator;
